export default "__VITE_ASSET__f4ec9eae__"